import { request } from '@/api/request';

/**
 * 获取企业信息
 * @returns Promise<any>
 */
export function getEnterpriseInfo(): Promise<any> {
  return request({
    url: '/id-enterprise/api/enterprise-info',
    method: 'GET',
  });
}

/**
 * 创建或更新企业信息
 * @param params 企业信息参数
 * @param params.id 企业ID
 * @param params.name 企业名称
 * @param params.mainIndustry 主营行业
 * @param params.logoUrl logo地址
 * @param params.legalPerson 法人代表
 * @param params.corporateNumber 企业编号
 * @param params.registrationDate 注册日期
 * @param params.capital 注册资本
 * @param params.companySizeId 企业规模ID
 * @param params.foreignEmployeeScaleId 外籍员工规模ID
 * @param params.revenueScaleId 营收规模ID
 * @param params.websiteUrl 网站地址
 * @param params.headOfficeJisCode 总部JIS代码
 * @param params.headOfficePrefectureName 总部都道府县名
 * @param params.headOfficeDetailedAddress 总部详细地址
 * @param params.companyProfile 企业简介
 * @param params.supportBusinessId 支持业务ID
 * @param params.delegationMethodId 委托方式ID
 * @param params.supportRemarks 支持备注
 * @param params.contactPersonName 联系人姓名
 * @param params.contactPersonPosition 联系人职位
 * @param params.contactPersonPhone 联系人电话
 * @param params.contactPersonEmail 联系人邮箱
 * @param params.remarks 备注
 * @returns Promise<any>
 */
export function saveEnterpriseInfo(params: Company.SaveEnterpriseInfoParams): Promise<any> {
  return request({
    url: '/id-enterprise/api/enterprise-info',
    method: 'POST',
    data: params
  });
}
